import { LogLevel } from "@azure/msal-browser";

// Use environment variables when available (set in .env) so you can switch between local and production easily.
const CLIENT_ID = process.env.REACT_APP_CLIENT_ID || "100ed91c-32f5-4187-9278-c7ab5e82232f";
const REDIRECT_URI = process.env.REACT_APP_REDIRECT_URI || window.location.origin;
const POST_LOGOUT_REDIRECT_URI = process.env.REACT_APP_POST_LOGOUT_REDIRECT_URI || window.location.origin;

export const msalConfig = {
  auth: {
    clientId: CLIENT_ID,
    authority: "https://login.microsoftonline.com/common",
    redirectUri: REDIRECT_URI,
    postLogoutRedirectUri: POST_LOGOUT_REDIRECT_URI,
    navigateToLoginRequestUrl: true
  },
  cache: {
    cacheLocation: "localStorage",
    // Mobile Safari's storage partitioning can lose the redirect state mid-flow,
    // which strands the login on the way back. A cookie survives that round trip.
    storeAuthStateInCookie: true
  },
  system: {
    loggerOptions: {
      loggerCallback: (level, message, containsPii) => {
        if (containsPii) return;
        switch (level) {
          case LogLevel.Error:
            console.error(message);
            return;
          case LogLevel.Info:
            console.info(message);
            return;
          case LogLevel.Verbose:
            console.debug(message);
            return;
          case LogLevel.Warning:
            console.warn(message);
            return;
          default:
            console.log(message);
        }
      }
    }
  }
};

export const loginRequest = {
  scopes: ["User.Read"],
  // Without this, the authorize endpoint silently reuses whichever Microsoft account
  // the browser is already signed into, so there is no way to pick a different one —
  // you just get logged straight back into the account you were trying to leave.
  prompt: "select_account"
};

// Scopes for calling our backend API
export const apiRequest = {
  scopes: [`api://100ed91c-32f5-4187-9278-c7ab5e82232f/access_as_user`]
};
